import { CountCellProps } from '../../types';
import { allPendingMappingStatusStrings } from '@constants';
import { Tooltip } from '@mui/material';
import TextWithSubtitle from 'components/TextWithSubtitle';
import { StyledCountWithSubtitleContainer } from './styles';
import { CellWithBorder } from 'shared/styles';
import { formatNumberWithComma } from 'utils';

const TotalPendingCountsCell = ({
  _customRowProps: { onPendingCellClick },
  totalPending,
  totalPendingUpdate,
  data,
}: CountCellProps) => {
  const { dataType } = data;

  return (
    <Tooltip
      placement="top"
      title={
        <div>
          <p>Total Pending (Create only): {formatNumberWithComma(totalPending)}</p>
          <p>Total Update: {formatNumberWithComma(totalPendingUpdate)}</p>
        </div>
      }
    >
      <StyledCountWithSubtitleContainer
        onClick={
          totalPending || totalPendingUpdate
            ? () => onPendingCellClick([dataType], allPendingMappingStatusStrings)
            : undefined
        }
      >
        {' '}
        <TextWithSubtitle
          mainText={formatNumberWithComma(totalPending)}
          mainTextClassName={+totalPending ? 'link-style clickable' : ''}
          subTitleClassName={totalPendingUpdate ? 'subtitle link-style clickable' : 'subtitle'}
          subtitle={formatNumberWithComma(totalPendingUpdate)}
        />
      </StyledCountWithSubtitleContainer>
    </Tooltip>
  );
};

export default TotalPendingCountsCell;
